import React, { useState, useEffect, useRef } from "react";
import {
    Paper,
    Grid,
    Typography,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    IconButton,
    Tooltip,
    Chip,
    Divider,
} from "@material-ui/core";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import ZoomOutMapIcon from "@mui/icons-material/ZoomOutMap";
import ZoomInMapIcon from "@mui/icons-material/ZoomInMap";
import AddIcon from "@material-ui/icons/Add";
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import {
    makeStyles,
    Theme,
    createStyles,
    withStyles,
} from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CallIcon from "@material-ui/icons/Call";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import CircularProgress from "@material-ui/core/CircularProgress"
import LinkIcon from "@material-ui/icons/Link";
import { connect } from "react-redux";
import moment from "moment";
import Loader from "../components/Loader2";
import { MessageRounded } from "@material-ui/icons";
import { CALL_DISABLE_TIME } from "../../CallTimeDisable";
import {
    getFranchiseInquiryList,
    clickToCallMobile,
    getUserDetails,
    getFranchiseInquiryDataById,
    getFranchiseDispositionList,
    getCities,
    updateFranchiseData,
    getFranchiseAssignUserList,
    getFranchiseInquiryLogs,
    createFranchiseInquiry,
    getDisplayCities
} from "../actions/OffLineSupportActions";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: "100%",
        },
        tableContainer: {
            marginTop: "2rem",
            maxHeight: "600px",
        },
        actionButton: {
            marginRight: 0,
            minWidth: "36px",
            padding: "6px",
        },

        phoneIconButton: {
            marginLeft: "8px",
            padding: "4px",
            color: "#1976d2",
            "&:disabled": {
                color: "#ccc",
            },
        },
        mobileCell: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            whiteSpace: "nowrap",
        },
        detailsContent: {
            padding: "24px",
            backgroundColor: "#f8f9fa",
        },
        detailsCard: {
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            padding: "20px",
            marginBottom: "16px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        },
        detailsHeader: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "20px",
            paddingBottom: "12px",
            borderBottom: "2px solid #e3f2fd",
        },
        detailsTitle: {
            fontSize: "18px",
            fontWeight: 600,
            color: "#0E3F6C",
            display: "flex",
            alignItems: "center",
            gap: "8px",
        },
        detailRow: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "12px 0",
            borderBottom: "1px solid #f0f0f0",
            "&:last-child": {
                borderBottom: "none",
            },
        },
        detailLabel: {
            fontWeight: 600,
            color: "#666",
            fontSize: "14px",
            minWidth: "140px",
        },
        detailValue: {
            color: "#333",
            fontSize: "14px",
            flex: 1,
            textAlign: "right",
            wordBreak: "break-word",
        },
        statusChip: {
            fontWeight: 600,
            textTransform: "capitalize",
        },
        linkButton: {
            color: "#1976d2",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            fontSize: "14px",
            "&:hover": {
                textDecoration: "underline",
            },
        },
        sectionTitle: {
            fontSize: "14px",
            fontWeight: 600,
            color: "#0E3F6C",
            marginTop: "16px",
            marginBottom: "8px",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
        },
        dispositionBox: {
            backgroundColor: "#f5f5f5",
            padding: "12px",
            borderRadius: "8px",
            marginTop: "8px",
        },
        paper: {
            backgroundColor: theme.palette.background.paper,
            border: "2px solid #000",
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
            width: "1200px",
        },
        createButton: {
            backgroundColor: "#0E3F6C",
            color: "#fff",
            "&:hover": {
                backgroundColor: "#0a2f4f",
            },
        },
    })
);

const StyledTableCell: any = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: "#0E3F6C",
            color: theme.palette.common.white,
            fontSize: "14px",
            whiteSpace: "nowrap",
        },
        body: {
            fontSize: 14,
            padding: "8px",
            textTransform: "capitalize",
            whiteSpace: "nowrap",
        },
    })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.palette.action.hover,
            },
        },
    })
)(TableRow);

interface Props {
    getFranchiseInquiryList: any;
    franchiseList: any;
    getFranchiseInquiryDataById: any;
    franchiseById: any;
    getFranchiseDispositionList: any
    franchiseDispositionList: any
    loading: any;
    clickToCallMobile: any;
    updateDisposition: any;
    assignLead: any;
    getUserDetails: any;
    usersList: any;
    getCities: any
    cities: any
    updateFranchiseData: any
    getFranchiseAssignUserList: any
    franchiseAssignUserList: any
    getFranchiseInquiryLogs: any
    franchiseInquiryLogs: any
    createFranchiseInquiry: any
    getDisplayCities: any
    displayCities: any
}

const FranchiseLeads: React.FC<Props> = ({
    getFranchiseInquiryList,
    franchiseList,
    loading,
    clickToCallMobile,
    updateDisposition,
    assignLead,
    getUserDetails,
    usersList,
    getFranchiseInquiryDataById,
    franchiseById,
    getFranchiseDispositionList,
    franchiseDispositionList,
    getCities,
    cities,
    updateFranchiseData,
    getFranchiseAssignUserList,
    franchiseAssignUserList,
    getFranchiseInquiryLogs,
    franchiseInquiryLogs,
    createFranchiseInquiry,
    getDisplayCities,
    displayCities
}) => {
    const classes = useStyles();
    const timer = useRef<any>(0);
    const [page, setPage] = useState(0);
    const [callButton, setCallButton] = useState(true);
    const [maxHeight, setMaxHeight] = React.useState<any>(300);

    // Filter states
    const [nameFilter, setNameFilter] = useState<any>("");
    const [mobileFilter, setMobileFilter] = useState<any>("");
    const [cityFilter, setCityFilter] = useState<any>("");
    const [fromDate, setFromDate] = useState<any>("");
    const [toDate, setToDate] = useState<any>("");
    const [dispositionFilter, setDispositionFilter] = useState<any>("");
    const [subDispositionFilter, setSubDispositionFilter] = useState<any>("");
    const [assignedUserFilter, setAssignedUserFilter] = useState<any>("");

    // Disposition Modal
    const [dispositionModal, setDispositionModal] = useState<any>(false);
    const [selectedLead, setSelectedLead] = useState<any>(null);
    const [disposition, setDisposition] = useState<any>("");
    const [subDisposition, setSubDisposition] = useState<any>("");

    // Assign User Modal
    const [assignModal, setAssignModal] = useState<any>(false);
    const [selectedUser, setSelectedUser] = useState<any>("");

    // Details Modal
    const [detailsModal, setDetailsModal] = useState<any>(false);

    const [openLogsModel, setopenLogsModal] = useState<any>(false)
    const [isEditMode, setIsEditMode] = useState<any>(false);
    const [editedLead, setEditedLead] = useState<any>(null);

    // Create Lead Modal and Form States
    const [createModal, setCreateModal] = useState<any>(false);
    const [newLead, setNewLead] = useState<any>({
        name: "",
        mobile: "",
        country_code: "+91",
        email: "",
        city: "",
        state: "",
        status: "New",
        disposition: "",
        sub_disposition: "",
        assigned_user: "",
        competition_cc_name: "",
        shop_type: "Owned",
        business_model_interest: "Collection Center",
        tata_sales_caller_remarks: "",
        url: "",
    });

    useEffect(() => {
        getFranchiseInquiryList();
        getCities("");
        getUserDetails("");
        getFranchiseDispositionList("");
        getFranchiseAssignUserList("");
    }, []);




    // Add this handler for editing lead fields
    const handleEditLeadChange = (field: string, value: any) => {
        setEditedLead((prev: any) => ({
            ...prev,
            [field]: value,
        }));
    };




    // Handler to save edited lead
    const handleSaveEdit = async () => {
        if (!editedLead.name || !editedLead.mobile) {
            alert("Name and Mobile are required fields");
            return;
        }

        // Validate mobile number
        const mobileRegex = /^[6-9]\d{9}$/;
        if (!mobileRegex.test(editedLead.mobile)) {
            alert("Mobile number must be exactly 10 digits and start with 6, 7, 8, or 9");
            return;
        }

        try {
            // Build payload object
            const payload = {
                name: editedLead.name,
                mobile: editedLead.mobile,
                country_code: editedLead.country_code,
                email: editedLead.email,
                city_name: editedLead.city,
                state: editedLead.state,
                status: editedLead.status,
                url: editedLead.url,
                disposition: editedLead.disposition_id,
                sub_disposition: editedLead.sub_disposition_id,
                assigned_user: editedLead.assigned_user_id,
                // Level 1 Interaction fields
                prospect_contact_status: editedLead.prospect_contact_status,
                interest_level: editedLead.interest_level,
                current_profession: editedLead.current_profession,
                competition_cc_name: editedLead.competition_cc_name,
                shop_type: editedLead.shop_type,
                business_model_interest: editedLead.business_model_interest,
                tale_sales_caller_remarks: editedLead.tata_sales_caller_remarks,
                // Level 2 Interaction fields
                business_model_interest_in: editedLead.business_model_interested_in,
                physical_meeting_status: editedLead.physical_meeting_status,
                meeting_date: editedLead.meeting_interaction_date,
                lead_status: editedLead.final_lead_status,
                sales_or_channel_team_remarks: editedLead.sales_channel_team_remarks,
                first_followup_date: editedLead.first_followup_date,
                sec_followup_date: editedLead.second_followup_date,
            };

            // Remove empty date fields
            if (!payload.meeting_date || payload.meeting_date === "") {
                delete payload.meeting_date;
            }

            if (!payload.first_followup_date || payload.first_followup_date === "") {
                delete payload.first_followup_date;
            }

            if (!payload.sec_followup_date || payload.sec_followup_date === "") {
                delete payload.sec_followup_date;
            }
            if (!payload.assigned_user || payload.assigned_user === "") {
                delete payload.assigned_user;
            }

            await updateFranchiseData(selectedLead.id, payload);

            setIsEditMode(false);
            getFranchiseInquiryList();
            getFranchiseInquiryDataById(`${selectedLead.id}`);
            alert("Lead updated successfully!");
        } catch (error) {
            console.error("Error updating lead:", error);
            alert("Failed to update lead. Please try again.");
        }
    };
    // Update the handleDetailsOpen function
    const handleDetailsOpen = (data: any) => {
        setSelectedLead(data);
        setEditedLead({
            name: data.name || "",
            mobile: data.mobile || "",
            country_code: data.country_code || "+91",
            email: data.email || "",
            city: data.city_name || "",
            state: data.state_name || "",
            status: data.status || "New",
            competition_cc_name: data.competition_cc_name || "",
            shop_type: data.shop_type || "Owned",
            business_model_interest: data.business_model_interest || "Collection Center",
            tata_sales_caller_remarks: data.tale_sales_caller_remarks || "",
            url: data.url || "",
            disposition_id: data.disposition?.id || "",
            sub_disposition_id: data.sub_disposition?.id || "",
            assigned_user_id: data.assigned_user_id || "",
            // Level 1 Interaction fields
            prospect_contact_status: data.prospect_contact_status || "",
            interest_level: data.interest_level || "",
            current_profession: data.current_profession || "",
            // Level 2 Interaction fields
            business_model_interested_in: data.business_model_interest_in || "",
            physical_meeting_status: data.physical_meeting_status || "",
            meeting_interaction_date: data.meeting_date ? data.meeting_date.split('T')[0] : "",
            final_lead_status: data.lead_status || "",
            sales_channel_team_remarks: data.sales_or_channel_team_remarks || "",
            first_followup_date: data.first_followup_date ? data.first_followup_date.split('T')[0] : "",
            second_followup_date: data.sec_followup_date ? data.sec_followup_date.split('T')[0] : "",
        });
        console.log(editedLead?.assigned_user,"editedLeadassigned_user")
        setIsEditMode(false);
        getFranchiseInquiryDataById(`${data.id}`);
        setDetailsModal(true);
    };

    useEffect(() => {
        getDisplayCities('?show_state=true')
    }, [])

    const handleCallClick = (data: any) => {
        setCallButton(false);
        clickToCallMobile(`${data?.mobile}`, "call")

        setTimeout(() => {
            setCallButton(true);
        }, CALL_DISABLE_TIME);
    };

    const handleDispositionOpen = (data: any) => {
        getFranchiseDispositionList("")
        setSelectedLead(data);
        setDisposition(data.disposition_id || "");
        setSubDisposition(data.sub_disposition_id || "");
        setDispositionModal(true);
    };

    const handleDispositionUpdate = async () => {
        if (!disposition) {
            alert("Please select a disposition");
            return;
        }

        await updateFranchiseData(selectedLead.id, {
            disposition: disposition,
            sub_disposition: subDisposition,
        });

        setDispositionModal(false);
        setDisposition("");
        setSubDisposition("");
        getFranchiseInquiryList();
    };

    const handleAssignOpen = (data: any) => {
        getFranchiseAssignUserList("")
        setSelectedLead(data);
        setSelectedUser(data.assigned_user || "");
        setAssignModal(true);
    };

    const handleAssignUpdate = async () => {
        if (!selectedUser) {
            alert("Please select a user");
            return;
        }

        await updateFranchiseData(selectedLead.id, {
            assigned_user: selectedUser,
        });

        setAssignModal(false);
        setSelectedUser("");
        getFranchiseInquiryList();
    };



    const handleFilter = () => {
        const queryParams = [];

        if (nameFilter) queryParams.push(`name=${nameFilter}`);
        if (mobileFilter) queryParams.push(`mobile=${mobileFilter}`);
        if (cityFilter) queryParams.push(`city=${cityFilter}`);
        if (fromDate) queryParams.push(`start_date=${fromDate}`);
        if (toDate) queryParams.push(`end_date=${toDate}`);
        if (dispositionFilter) queryParams.push(`disposition=${dispositionFilter}`);
        if (subDispositionFilter) queryParams.push(`sub_disposition=${subDispositionFilter}`);
        if (assignedUserFilter) queryParams.push(`assigned_user=${assignedUserFilter}`);

        const queryString = queryParams.length > 0 ? `${queryParams.join("&")}` : "";
        getFranchiseInquiryList(queryString);
    };

    const handleReset = () => {
        setNameFilter("");
        setMobileFilter("");
        setCityFilter("");
        setFromDate("");
        setToDate("");
        setDispositionFilter("");
        setSubDispositionFilter("");
        setAssignedUserFilter("");
        getFranchiseInquiryList();
    };

    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number
    ) => {
        if (newPage > page) {
            let url = franchiseList.links && franchiseList.links.next.split("?")[1];
            getFranchiseInquiryList(`${url}`);
        } else if (newPage < page) {
            let url = franchiseList.links && franchiseList.links.previous.split("?")[1];
            getFranchiseInquiryList(`${url}`);
        }
        setPage(newPage);
    };

    const getStatusColor = (status: string) => {
        const statusColors: any = {
            pending: "#ff9800",
            completed: "#4caf50",
            in_progress: "#2196f3",
            cancelled: "#f44336",
        };
        return statusColors[status] || "#757575";
    };

    const formatDisposition = (value: any) => {
        if (!value) return "N/A";
        const stringValue = String(value);
        return stringValue.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
    };

    const handleLogsClick = (data: any) => {
        setopenLogsModal(true);
        getFranchiseInquiryLogs(`enq_id=${data.id}`)
    }

    const handleClose = () => {
        setopenLogsModal(false);
    }

    // Create Lead Handlers
    const handleCreateOpen = () => {
        setNewLead({
            name: "",
            phone_no: "",
            country_code: "+91",
            email: "",
            city: "",
            state: ""
        });
        setCreateModal(true);
    };

    const handleCreateLead = async () => {
        // Validation
        if (!newLead.name || !newLead.phone_no) {
            alert("Name and Mobile are required fields");
            return;
        }

        if (newLead.phone_no.length < 10) {
            alert("Please enter a valid mobile number");
            return;
        }

        try {
            // Call your API to create franchise lead
            await createFranchiseInquiry(newLead);

            // For now, just close modal and refresh list
            setCreateModal(false);
            getFranchiseInquiryList();
            alert("Lead created successfully!");
        } catch (error) {
            console.error("Error creating lead:", error);
            alert("Failed to create lead. Please try again.");
        }
    };

    const handleNewLeadChange = (field: string, value: any) => {
        // Special validation for phone number
        if (field === "phone_no") {

            // Allow digits only
            let cleaned = value.replace(/\D/g, "");

            // Max 10 digits
            if (cleaned.length > 10) {
                cleaned = cleaned.slice(0, 10);
            }

            // Update state with validated phone number
            setNewLead((prev: any) => ({
                ...prev,
                phone_no: cleaned,
            }));

            return; // Exit early
        }

        // Default behavior for all other fields
        setNewLead((prev: any) => ({
            ...prev,
            [field]: value,
        }));
    };

    return (
        <div style={{ padding: "50px 0", width: "100%" }}>
            <Grid container style={{ margin: "25px auto" }}>
                <Grid container item xs={12}>
                    <Grid container item xs={12} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Typography variant="h4" component="h1" align="left">
                            <b>Franchise Leads</b>
                        </Typography>
                        <Button
                            variant="contained"
                            className={classes.createButton}
                            startIcon={<AddIcon />}
                            onClick={handleCreateOpen}
                        >
                            Create Franchise Lead
                        </Button>
                    </Grid>
                </Grid>

                {/* Filters */}
                <Grid container xs={12} style={{ marginTop: "20px" }}>
                    <Grid container xs={12} spacing={2}>
                        <Grid item xs={12} sm={6} md={2}>
                            <TextField
                                label="Name"
                                fullWidth
                                variant="outlined"
                                className="input"
                                value={nameFilter}
                                onChange={(e) => setNameFilter(e.target.value)}
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <TextField
                                label="Mobile"
                                fullWidth
                                variant="outlined"
                                value={mobileFilter}
                                className="input"
                                onChange={(e) => setMobileFilter(e.target.value)}
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <Autocomplete
                                id="city"
                                onChange={(event, newValue) => {
                                    if (newValue) {
                                        setCityFilter([newValue.name]);
                                    } else {
                                        setCityFilter([]);
                                    }
                                }}
                                options={cities || []}
                                freeSolo
                                blurOnSelect
                                aria-required
                                limitTags={1}
                                getOptionLabel={(option: any) => option.name}
                                disableClearable
                                onInputChange={(event, newInputValue) => {
                                    clearTimeout(timer.current);
                                    timer.current = setTimeout(() => {
                                        getCities(newInputValue);
                                    }, 1000);
                                    if (newInputValue.length === 0) {
                                        setCityFilter([]);
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        className="input"
                                        {...params}
                                        label="City"
                                        variant="outlined"
                                        style={{ width: "100%", margin: "0", padding: "0" }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <FormControl fullWidth variant="outlined" size="small">
                                <InputLabel>Disposition</InputLabel>
                                <Select
                                    value={dispositionFilter}
                                    className="input"
                                    style={{ height: "40px" }}
                                    onChange={(e: any) => setDispositionFilter(e.target.value)}
                                    label="Disposition"
                                >
                                    <MenuItem value="">All</MenuItem>
                                    {franchiseDispositionList?.results &&
                                        franchiseDispositionList.results.length > 0 &&
                                        franchiseDispositionList.results.map((d: any) => (
                                            <MenuItem key={d.id} value={d.id}>
                                                {d.name}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <Autocomplete
                                id="assigned-user"
                                onChange={(event, newValue) => {
                                    if (newValue) {
                                        setAssignedUserFilter(newValue.id);
                                    } else {
                                        setAssignedUserFilter("");
                                    }
                                }}
                                options={franchiseAssignUserList?.results || []}
                                freeSolo
                                blurOnSelect
                                aria-required
                                limitTags={1}
                                getOptionLabel={(option: any) => option.username || ""}
                                disableClearable
                                onInputChange={(event, newInputValue) => {
                                    clearTimeout(timer.current);
                                    timer.current = setTimeout(() => {
                                        getFranchiseAssignUserList(newInputValue);
                                    }, 1000);
                                    if (newInputValue.length === 0) {
                                        setAssignedUserFilter("");
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        className="input"
                                        {...params}
                                        label="Assigned User"
                                        variant="outlined"
                                        style={{ width: "100%", margin: "0", padding: "0" }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <TextField
                                name="fromDate"
                                label="From Date"
                                variant="outlined"
                                fullWidth
                                value={fromDate}
                                className="input"
                                onChange={(e) => setFromDate(e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                type="date"
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <TextField
                                name="toDate"
                                label="To Date"
                                variant="outlined"
                                fullWidth
                                value={toDate}
                                className="input"
                                onChange={(e) => setToDate(e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                type="date"
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={handleFilter}
                                fullWidth
                                style={{ height: "40px" }}
                            >
                                Filter
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleReset}
                                fullWidth
                                style={{ height: "40px" }}
                            >
                                Reset
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>

                {/* Table */}
                <Grid container xs={12}>
                    <div style={{ width: "100%" }}>
                        <TableContainer
                            className={classes.tableContainer}
                            component={Paper}
                        >
                            {loading ? (
                                <Loader />
                            ) : (
                                <Table stickyHeader aria-label="franchise leads table">
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align="center">
                                                <b>Name</b>
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                <b>Mobile</b>
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                <b>Email</b>
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                <b>City</b>
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                <b>State</b>
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                <b>Status</b>
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                <b>Disposition</b>
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                <b>Sub Disposition</b>
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                <b>Assigned User</b>
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                <b>Lead Date</b>
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                <b>Actions</b>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {franchiseList?.results &&
                                            franchiseList?.results.length > 0 &&
                                            franchiseList?.results.map((data: any, index: number) => (
                                                <StyledTableRow key={data.id}>
                                                    <StyledTableCell align="center">
                                                        {data.name}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", whiteSpace: "nowrap" }}>
                                                            <span style={{ fontWeight: 600 }}>
                                                                {data.country_code} {data.mobile}
                                                            </span>
                                                        </div>
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        <div className={classes.mobileCell}>
                                                            NA
                                                        </div>
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        {data.city_name || "N/A"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        {data.state_name || "N/A"}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        <Chip
                                                            label={data.status || "New"}
                                                            size="small"
                                                            style={{
                                                                backgroundColor: getStatusColor(data.status),
                                                                color: "#fff",
                                                                fontWeight: 600,
                                                            }}
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        {data?.disposition ? (
                                                            <Chip
                                                                label={formatDisposition(data?.disposition?.name)}
                                                                size="small"
                                                                color="primary"
                                                                variant="outlined"
                                                            />
                                                        ) : (
                                                            "N/A"
                                                        )}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        {data?.sub_disposition ? (
                                                            <Chip
                                                                label={formatDisposition(data.sub_disposition.name)}
                                                                size="small"
                                                                color="primary"
                                                                variant="outlined"
                                                            />
                                                        ) : (
                                                            "N/A"
                                                        )}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        {data.assigned_user ? (
                                                            <Tooltip title={`Assigned to ${data.assigned_user}`}>
                                                                <Box
                                                                    display="flex"
                                                                    alignItems="center"
                                                                    justifyContent="center"
                                                                    style={{
                                                                        backgroundColor: "#e8f5e9",
                                                                        padding: "6px 12px",
                                                                        borderRadius: "16px",
                                                                        border: "1px solid #4caf50",
                                                                    }}
                                                                >
                                                                    <AssignmentIndIcon
                                                                        style={{
                                                                            fontSize: "16px",
                                                                            color: "#2e7d32",
                                                                            marginRight: "4px",
                                                                        }}
                                                                    />
                                                                    <Typography
                                                                        variant="body2"
                                                                        style={{
                                                                            color: "#2e7d32",
                                                                            fontWeight: 600,
                                                                            fontSize: "13px",
                                                                        }}
                                                                    >
                                                                        {data.assigned_user.length > 15
                                                                            ? data.assigned_user.substring(0, 15) + "..."
                                                                            : data.assigned_user}
                                                                    </Typography>
                                                                </Box>
                                                            </Tooltip>
                                                        ) : (
                                                            <Typography
                                                                variant="body2"
                                                                style={{
                                                                    color: "#999",
                                                                    fontStyle: "italic",
                                                                }}
                                                            >
                                                                Not Assigned
                                                            </Typography>
                                                        )}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        {moment(data.created_at).format("DD-MM-YYYY HH:mm")}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        <Box display="flex" alignItems="center" justifyContent="center" flexWrap="nowrap" gap={0.5}>
                                                            <Tooltip title="View Details">
                                                                <IconButton
                                                                    className={classes.actionButton}
                                                                    color="primary"
                                                                    onClick={() => handleDetailsOpen(data)}
                                                                    size="small"
                                                                >
                                                                    <VisibilityIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="Click to Call">
                                                                <span>
                                                                    <IconButton
                                                                        className={classes.actionButton}
                                                                        disabled={!callButton}
                                                                        color="primary"
                                                                        onClick={() => handleCallClick(data)}
                                                                        size="small"
                                                                    >
                                                                        <CallIcon />
                                                                    </IconButton>
                                                                </span>
                                                            </Tooltip>
                                                            <Tooltip title="Update Disposition">
                                                                <IconButton
                                                                    className={classes.actionButton}
                                                                    color="secondary"
                                                                    onClick={() => handleDispositionOpen(data)}
                                                                    size="small"
                                                                >
                                                                    <EditIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="Assign Lead">
                                                                <IconButton
                                                                    className={classes.actionButton}
                                                                    style={{ color: "#1874a5" }}
                                                                    onClick={() => handleAssignOpen(data)}
                                                                    size="small"
                                                                >
                                                                    <AssignmentIndIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="Logs">
                                                                <IconButton
                                                                    className={classes.actionButton}
                                                                    style={{ color: "#1874a5" }}
                                                                    onClick={() => handleLogsClick(data)}
                                                                    size="small"
                                                                >
                                                                    <MessageRounded />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Box>
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            ))}
                                    </TableBody>
                                    <TableFooter>
                                        <TableRow>
                                            <TablePagination
                                                rowsPerPageOptions={[]}
                                                colSpan={9}
                                                count={franchiseList?.count || 0}
                                                rowsPerPage={franchiseList?.page_size || 10}
                                                page={page}
                                                onPageChange={handleChangePage}
                                            />
                                        </TableRow>
                                    </TableFooter>
                                </Table>
                            )}
                        </TableContainer>
                    </div>
                </Grid>
            </Grid>

            {/* Create Lead Modal */}
            <Dialog
                open={createModal}
                onClose={() => setCreateModal(false)}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle style={{ backgroundColor: "#0E3F6C", color: "#fff" }}>
                    Create New Franchise Lead
                </DialogTitle>
                <DialogContent style={{ paddingTop: "20px" }}>
                    <Grid container spacing={3}>
                        {/* Personal Information */}
                        <Grid item xs={12}>
                            <Typography variant="subtitle1" style={{ fontWeight: 600, color: "#0E3F6C", marginBottom: "10px" }}>
                                Personal Information
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Name "
                                fullWidth
                                variant="outlined"
                                className="input"

                                value={newLead.name}
                                onChange={(e) => handleNewLeadChange("name", e.target.value)}
                                required
                            />
                        </Grid>

                        <Grid item xs={12} sm={2}>
                            <TextField
                                label="Country Code"
                                fullWidth
                                className="input"
                                variant="outlined"

                                value={newLead.country_code}
                                onChange={(e) => handleNewLeadChange("country_code", e.target.value)}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <TextField
                                label="Mobile"
                                fullWidth
                                className="input"
                                variant="outlined"

                                value={newLead.phone_no}
                                onChange={(e) => handleNewLeadChange("phone_no", e.target.value)}
                                required
                                type="tel"
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Email"
                                fullWidth
                                variant="outlined"
                                className="input"
                                value={newLead.email}
                                onChange={(e) => handleNewLeadChange("email", e.target.value)}
                                type="email"
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Autocomplete
                                id="create-city"
                                value={newLead.city}
                                className="input"
                                onChange={(event, newValue) => {
                                    handleNewLeadChange("city", newValue?.name || "");
                                }}
                                options={cities || []}
                                freeSolo
                                getOptionLabel={(option: any) => typeof option === 'string' ? option : option.name}
                                onInputChange={(event, newInputValue) => {
                                    clearTimeout(timer.current);
                                    timer.current = setTimeout(() => {
                                        getCities(newInputValue);
                                    }, 1000);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="City"
                                        variant="outlined"
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Autocomplete
                                id="create-state"
                                value={newLead.state}
                                className="input"
                                onChange={(event, newValue) => {
                                    handleNewLeadChange("state", newValue || "");
                                }}
                                options={displayCities?.state || []}
                                freeSolo
                                getOptionLabel={(option) => option}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="State"
                                        variant="outlined"
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ padding: "16px 24px" }}>
                    <Button onClick={() => setCreateModal(false)} variant="outlined">
                        Cancel
                    </Button>
                    <Button
                        onClick={handleCreateLead}
                        variant="contained"
                        className={classes.createButton}
                    >
                        Create Lead
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Enhanced Details Modal */}
            <Dialog
                open={detailsModal}
                onClose={() => {
                    setDetailsModal(false);
                    setIsEditMode(false);
                }}
                maxWidth="lg"
                fullWidth
                PaperProps={{
                    style: {
                        maxHeight: '90vh',
                    }
                }}
            >
                <DialogTitle style={{ backgroundColor: "#0E3F6C", color: "#fff" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span>{isEditMode ? "Edit Lead Details" : "Lead Details"}</span>
                        {selectedLead && !isEditMode && (
                            <Chip
                                label={selectedLead.status || "New"}
                                size="small"
                                style={{
                                    backgroundColor: getStatusColor(selectedLead.status),
                                    color: "#fff",
                                    fontWeight: 600,
                                }}
                            />
                        )}
                    </div>
                </DialogTitle>
                <DialogContent className={classes.detailsContent} style={{ overflowY: 'auto' }}>
                    {selectedLead && editedLead && (
                        <Box>
                            {/* Personal Information */}
                            <div className={classes.detailsCard}>
                                <div className={classes.sectionTitle}>Personal Information</div>
                                {isEditMode ? (
                                    <Grid container spacing={2} style={{ marginTop: "8px" }}>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label="Name"
                                                fullWidth
                                                variant="outlined"
                                                className="input"
                                                value={editedLead.name}
                                                onChange={(e) => handleEditLeadChange("name", e.target.value)}
                                                required
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <TextField
                                                label="Country Code"
                                                fullWidth
                                                variant="outlined"
                                                className="input"
                                                value={editedLead.country_code}
                                                onChange={(e) => handleEditLeadChange("country_code", e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <TextField
                                                label="Mobile"
                                                fullWidth
                                                variant="outlined"
                                                className="input"
                                                value={editedLead.mobile}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*$/.test(value) && value.length <= 10) {
                                                        handleEditLeadChange("mobile", value);
                                                    }
                                                }}
                                                required
                                                type="tel"
                                                inputProps={{
                                                    maxLength: 10,
                                                    pattern: "[6-9][0-9]{9}"
                                                }}
                                                helperText="Start with 6-9, exactly 10 digits"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label="Email"
                                                fullWidth
                                                variant="outlined"
                                                className="input"
                                                value={editedLead.email}
                                                onChange={(e) => handleEditLeadChange("email", e.target.value)}
                                                type="email"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <Autocomplete
                                                id="edit-city"
                                                value={editedLead.city}
                                                onChange={(event, newValue) => {
                                                    handleEditLeadChange("city", newValue?.name || "");
                                                }}
                                                options={cities || []}
                                                freeSolo
                                                getOptionLabel={(option: any) =>
                                                    typeof option === 'string' ? option : option.name
                                                }
                                                onInputChange={(event, newInputValue) => {
                                                    clearTimeout(timer.current);
                                                    timer.current = setTimeout(() => {
                                                        getCities(newInputValue);
                                                    }, 1000);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="City"
                                                        variant="outlined"
                                                        className="input"
                                                    />
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <TextField
                                                label="State"
                                                fullWidth
                                                variant="outlined"
                                                className="input"
                                                value={editedLead.state}
                                                onChange={(e) => handleEditLeadChange("state", e.target.value)}
                                            />
                                        </Grid>
                                    </Grid>
                                ) : (
                                    <>
                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>Name:</span>
                                            <span className={classes.detailValue}>{selectedLead.name}</span>
                                        </div>
                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>Mobile:</span>
                                            <span className={classes.detailValue}>
                                                {selectedLead.country_code} {selectedLead.mobile}
                                            </span>
                                        </div>
                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>Email:</span>
                                            <span className={classes.detailValue}>
                                                {selectedLead.email || "N/A"}
                                            </span>
                                        </div>
                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>City:</span>
                                            <span className={classes.detailValue}>
                                                {selectedLead.city_name || "N/A"}
                                            </span>
                                        </div>
                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>State:</span>
                                            <span className={classes.detailValue}>
                                                {selectedLead.state_name || "N/A"}
                                            </span>
                                        </div>
                                    </>
                                )}
                            </div>

                            {/* Lead Information */}
                            <div className={classes.detailsCard}>
                                <div className={classes.sectionTitle}>Lead Information</div>
                                {isEditMode ? (
                                    <Grid container spacing={2} style={{ marginTop: "8px" }}>
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                label="Lead ID"
                                                fullWidth
                                                variant="outlined"
                                                className="input"
                                                value={selectedLead.id}
                                                disabled
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <FormControl fullWidth variant="outlined">
                                                <InputLabel>Status</InputLabel>
                                                <Select
                                                    value={editedLead.status}
                                                    onChange={(e) => handleEditLeadChange("status", e.target.value)}
                                                    label="Status"
                                                    className="input"
                                                >
                                                    <MenuItem value="pending">Pending</MenuItem>
                                                    <MenuItem value="confirmed">Confirmed</MenuItem>
                                                    <MenuItem value="applied">Applied</MenuItem>
                                                    <MenuItem value="verified_by_call_center">Verified by Call Center</MenuItem>
                                                    <MenuItem value="application_approved">Application Approved</MenuItem>
                                                    <MenuItem value="initial_document_uploaded">Initial document uploaded</MenuItem>
                                                    <MenuItem value="business_site_not_updated">Business Site Not updated</MenuItem>
                                                    <MenuItem value="business_site_accepted">Business Site Accepted</MenuItem>
                                                    <MenuItem value="documents_uploaded">Documents Uploaded</MenuItem>
                                                    <MenuItem value="documents_accepted">Documents Accepted</MenuItem>
                                                    <MenuItem value="documents_rejected">Documents Rejected</MenuItem>
                                                    <MenuItem value="cc_code_created">CC Code Created</MenuItem>
                                                    <MenuItem value="cc_code_live">CC Code Live</MenuItem>
                                                    <MenuItem value="cc_code_closed">CC Code Closed</MenuItem>
                                                    <MenuItem value="application_rejected">Application Rejected</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                label="Source URL"
                                                fullWidth
                                                variant="outlined"
                                                className="input"
                                                value={editedLead.url}
                                                onChange={(e) => handleEditLeadChange("url", e.target.value)}
                                                type="url"
                                            />
                                        </Grid>
                                    </Grid>
                                ) : (
                                    <>
                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>Lead ID:</span>
                                            <span className={classes.detailValue}>#{selectedLead.id}</span>
                                        </div>
                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>Created At:</span>
                                            <span className={classes.detailValue}>
                                                {moment(selectedLead.created_at).format("DD-MM-YYYY HH:mm:ss")}
                                            </span>
                                        </div>
                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>Status:</span>
                                            <span className={classes.detailValue}>
                                                <Chip
                                                    label={selectedLead.status || "New"}
                                                    size="small"
                                                    className={classes.statusChip}
                                                    style={{
                                                        backgroundColor: getStatusColor(selectedLead.status),
                                                        color: "#fff",
                                                    }}
                                                />
                                            </span>
                                        </div>
                                        {selectedLead.url && (
                                            <div className={classes.detailRow}>
                                                <span className={classes.detailLabel}>Source URL:</span>
                                                <span className={classes.detailValue}>
                                                    <a
                                                        href={selectedLead.url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className={classes.linkButton}
                                                    >
                                                        <LinkIcon style={{ fontSize: "16px" }} />
                                                        View Source
                                                    </a>
                                                </span>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                            {/* Disposition & Assignment */}
                            <div className={classes.detailsCard}>
                                <div className={classes.sectionTitle}>Disposition & Assignment</div>
                                {isEditMode ? (
                                    <Grid container spacing={2} style={{ marginTop: "8px" }}>
                                        <Grid item xs={12} sm={6}>
                                            <Autocomplete
                                                id="edit-disposition"
                                                value={
                                                    franchiseDispositionList?.results?.find(
                                                        (d: any) => d.id === editedLead.disposition_id
                                                    ) || null
                                                }
                                                onChange={(event, newValue) => {
                                                    if (newValue) {
                                                        handleEditLeadChange("disposition_id", newValue.id);
                                                        handleEditLeadChange("sub_disposition_id", "");
                                                    } else {
                                                        handleEditLeadChange("disposition_id", "");
                                                        handleEditLeadChange("sub_disposition_id", "");
                                                    }
                                                }}
                                                options={franchiseDispositionList?.results || []}
                                                getOptionLabel={(option: any) => option.name || ""}
                                                renderInput={(params) => (
                                                    <TextField
                                                        className="input"
                                                        {...params}
                                                        label="Disposition"
                                                        variant="outlined"
                                                    />
                                                )}
                                            />
                                        </Grid>
                                        {editedLead.disposition_id && (
                                            <Grid item xs={12} sm={6}>
                                                <Autocomplete
                                                    id="edit-sub-disposition"
                                                    value={
                                                        franchiseDispositionList?.results
                                                            ?.find((d: any) => d.id === editedLead.disposition_id)
                                                            ?.sub_disposition_list?.find(
                                                                (sd: any) => sd.id === editedLead.sub_disposition_id
                                                            ) || null
                                                    }
                                                    onChange={(event, newValue) => {
                                                        if (newValue) {
                                                            handleEditLeadChange("sub_disposition_id", newValue.id);
                                                        } else {
                                                            handleEditLeadChange("sub_disposition_id", "");
                                                        }
                                                    }}
                                                    options={
                                                        franchiseDispositionList?.results
                                                            ?.find((d: any) => d.id === editedLead.disposition_id)
                                                            ?.sub_disposition_list || []
                                                    }
                                                    getOptionLabel={(option: any) => option.name || ""}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            className="input"
                                                            {...params}
                                                            label="Sub Disposition"
                                                            variant="outlined"
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        )}
                                    </Grid>
                                ) : (
                                    <>
                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>Disposition:</span>
                                            <span className={classes.detailValue}>
                                                {selectedLead?.disposition?.name ? (
                                                    <Chip
                                                        label={formatDisposition(selectedLead.disposition.name)}
                                                        size="small"
                                                        color="primary"
                                                        variant="outlined"
                                                    />
                                                ) : (
                                                    "N/A"
                                                )}
                                            </span>
                                        </div>
                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>Sub Disposition:</span>
                                            <span className={classes.detailValue}>
                                                {selectedLead?.sub_disposition?.name ? (
                                                    <Chip
                                                        label={formatDisposition(selectedLead.sub_disposition.name)}
                                                        size="small"
                                                        color="secondary"
                                                        variant="outlined"
                                                    />
                                                ) : (
                                                    "N/A"
                                                )}
                                            </span>
                                        </div>
                                    </>
                                )}
                            </div>

                            {/* Level 1 Interaction - Tele Sales Client */}
                            <div className={classes.detailsCard}>
                                <div className={classes.sectionTitle}>Level 1 Interaction (Tele Sales Client)</div>
                                {isEditMode ? (
                                    <Grid container spacing={2} style={{ marginTop: "8px" }}>

                                        <Grid item xs={12} sm={12}>
                                            <FormControl fullWidth variant="outlined">
                                                <InputLabel>Interest Level</InputLabel>
                                                <Select
                                                    value={editedLead.interest_level}
                                                    onChange={(e) => handleEditLeadChange("interest_level", e.target.value)}
                                                    label="Interest Level"
                                                    className="input"
                                                >
                                                    <MenuItem value="interested">Interested</MenuItem>
                                                    <MenuItem value="not_interested">Not Interested</MenuItem>
                                                    <MenuItem value="non_feasible_area">Non-Feasible Area</MenuItem>
                                                    <MenuItem value="other">Other</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth variant="outlined">
                                                <InputLabel>Current Profession</InputLabel>
                                                <Select
                                                    value={editedLead.current_profession}
                                                    onChange={(e) => handleEditLeadChange("current_profession", e.target.value)}
                                                    label="Current Profession"
                                                    className="input"
                                                >
                                                    <MenuItem value="technician">Technician</MenuItem>
                                                    <MenuItem value="phlebo">Phlebo</MenuItem>
                                                    <MenuItem value="competition_cc">Competition CC</MenuItem>
                                                    <MenuItem value="runs_a_lab_dc">Runs a Lab, DC</MenuItem>
                                                    <MenuItem value="chemist">Chemist</MenuItem>
                                                    <MenuItem value="pvt_employee">Pvt Employee</MenuItem>
                                                    <MenuItem value="govt_employee">Govt Employee</MenuItem>
                                                    <MenuItem value="works_in_hospital">Works in Hospital</MenuItem>
                                                    <MenuItem value="investor">Investor</MenuItem>
                                                    <MenuItem value="other">Other</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label="Name of Competition CC"
                                                fullWidth
                                                variant="outlined"
                                                className="input"
                                                value={editedLead.competition_cc_name}
                                                onChange={(e) => handleEditLeadChange("competition_cc_name", e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth variant="outlined">
                                                <InputLabel>Shop Type</InputLabel>
                                                <Select
                                                    value={editedLead.shop_type}
                                                    onChange={(e) => handleEditLeadChange("shop_type", e.target.value)}
                                                    label="Shop Type"
                                                    className="input"
                                                >
                                                    <MenuItem value="owned">Owned</MenuItem>
                                                    <MenuItem value="rent">Rent</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth variant="outlined">
                                                <InputLabel>Business Model Interest</InputLabel>
                                                <Select
                                                    value={editedLead.business_model_interest}
                                                    onChange={(e) => handleEditLeadChange("business_model_interest", e.target.value)}
                                                    label="Business Model Interest"
                                                    className="input"
                                                >
                                                    <MenuItem value="collection_center">Collection Center</MenuItem>
                                                    <MenuItem value="direct_client">Direct Client</MenuItem>
                                                    <MenuItem value="hlm">HLM</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                label="Tele Sales Caller Remarks"
                                                fullWidth
                                                variant="outlined"
                                                className="input"
                                                multiline
                                                rows={3}
                                                value={editedLead.tata_sales_caller_remarks}
                                                onChange={(e) => handleEditLeadChange("tata_sales_caller_remarks", e.target.value)}
                                            />
                                        </Grid>
                                    </Grid>
                                ) : (
                                    <>

                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>Interest Level:</span>
                                            <span className={classes.detailValue}>
                                                {selectedLead.interest_level || "N/A"}
                                            </span>
                                        </div>
                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>Current Profession:</span>
                                            <span className={classes.detailValue}>
                                                {selectedLead.current_profession || "N/A"}
                                            </span>
                                        </div>
                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>Name of Competition CC:</span>
                                            <span className={classes.detailValue}>
                                                {selectedLead.competition_cc_name || "N/A"}
                                            </span>
                                        </div>
                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>Shop Type:</span>
                                            <span className={classes.detailValue}>
                                                {selectedLead.shop_type || "N/A"}
                                            </span>
                                        </div>
                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>Business Model Interest:</span>
                                            <span className={classes.detailValue}>
                                                {selectedLead.business_model_interest || "N/A"}
                                            </span>
                                        </div>
                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>Tele Sales Caller Remarks:</span>
                                            <span className={classes.detailValue}>
                                                {selectedLead.tale_sales_caller_remarks || "N/A"}
                                            </span>
                                        </div>
                                    </>
                                )}
                            </div>

                            {/* Level 2 Interaction - ASM Feedback */}
                            <div className={classes.detailsCard}>
                                <div className={classes.sectionTitle}>Level 2 Interaction (ASM Feedback)</div>
                                {isEditMode ? (
                                    <Grid container spacing={2} style={{ marginTop: "8px" }}>
                                        <Grid item xs={12} sm={6}>
                                            <Autocomplete
                                                id="edit-assign-user"
                                               
                                                value={
                                                    franchiseAssignUserList?.results?.find(
                                                        (user: any) => user.id === editedLead.assigned_user_id  // CHANGED: Match with assigned_user from backend
                                                    ) || null
                                                }
                                                onChange={(event, newValue) => {
                                                    if (newValue) {
                                                        handleEditLeadChange("assigned_user_id", newValue.id);  // CHANGED: Use assigned_user
                                                    } else {
                                                        handleEditLeadChange("assigned_user_id", "");
                                                    }
                                                }}
                                                options={franchiseAssignUserList?.results || []}
                                                getOptionLabel={(option: any) => option.username || ""}
                                                onInputChange={(event, newInputValue) => {
                                                    clearTimeout(timer.current);
                                                    timer.current = setTimeout(() => {
                                                        getFranchiseAssignUserList(`name=${newInputValue.replace(" ", "")}`);
                                                    }, 1000);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        className="input"
                                                        {...params}
                                                        label="Assigned To ASM"
                                                        variant="outlined"
                                                    />
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth variant="outlined">
                                                <InputLabel>Business Model Interested In</InputLabel>
                                                <Select
                                                    value={editedLead.business_model_interested_in}
                                                    onChange={(e) => handleEditLeadChange("business_model_interested_in", e.target.value)}
                                                    label="Business Model Interested In"
                                                    className="input"
                                                >
                                                    <MenuItem value="1_lakh_model">1 Lakh Model</MenuItem>
                                                    <MenuItem value="50k_model">50K Model</MenuItem>
                                                    <MenuItem value="35k_model">35K Model</MenuItem>
                                                    <MenuItem value="others">Others</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth variant="outlined">
                                                <InputLabel>Physical Meeting Status</InputLabel>
                                                <Select
                                                    value={editedLead.physical_meeting_status}
                                                    onChange={(e) => handleEditLeadChange("physical_meeting_status", e.target.value)}
                                                    label="Physical Meeting Status"
                                                    className="input"
                                                >
                                                    <MenuItem value="yes">Yes</MenuItem>
                                                    <MenuItem value="no">No</MenuItem>
                                                    <MenuItem value="pending">Pending</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                name="meeting_interaction_date"
                                                label="Meeting/Interaction Date"
                                                variant="outlined"
                                                fullWidth
                                                value={editedLead.meeting_interaction_date}
                                                className="input"
                                                onChange={(e) => handleEditLeadChange("meeting_interaction_date", e.target.value)}
                                                InputLabelProps={{ shrink: true }}
                                                type="date"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth variant="outlined">
                                                <InputLabel>Final Lead Status</InputLabel>
                                                <Select
                                                    value={editedLead.final_lead_status}
                                                    onChange={(e) => handleEditLeadChange("final_lead_status", e.target.value)}
                                                    label="Final Lead Status"
                                                    className="input"
                                                >
                                                    <MenuItem value="payment_collected">Payment Collected</MenuItem>
                                                    <MenuItem value="not_interested_anymore">Not Interested Anymore</MenuItem>
                                                    <MenuItem value="will_take_time_to_decide">Will Take Time To Decide</MenuItem>
                                                    <MenuItem value="will_make_payment_soon">Will Make Payment Soon</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label="Sales/Channel Team Remarks"
                                                fullWidth
                                                variant="outlined"
                                                className="input"
                                                value={editedLead.sales_channel_team_remarks}
                                                onChange={(e) => handleEditLeadChange("sales_channel_team_remarks", e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                name="first_followup_date"
                                                label="1st Follow-Up Date"
                                                variant="outlined"
                                                fullWidth
                                                value={editedLead.first_followup_date}
                                                className="input"
                                                onChange={(e) => handleEditLeadChange("first_followup_date", e.target.value)}
                                                InputLabelProps={{ shrink: true }}
                                                type="date"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                name="second_followup_date"
                                                label="2nd Follow-Up Date"
                                                variant="outlined"
                                                fullWidth
                                                value={editedLead.second_followup_date}
                                                className="input"
                                                onChange={(e) => handleEditLeadChange("second_followup_date", e.target.value)}
                                                InputLabelProps={{ shrink: true }}
                                                type="date"
                                            />
                                        </Grid>
                                    </Grid>
                                ) : (
                                    <>
                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>Assigned To ASM:</span>
                                            <span className={classes.detailValue}>
                                                {selectedLead.assigned_user || "Not Assigned"}
                                            </span>
                                        </div>
                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>Business Model Interested In:</span>
                                            <span className={classes.detailValue}>
                                                {selectedLead.business_model_interest || "N/A"}
                                            </span>
                                        </div>
                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>Physical Meeting Status:</span>
                                            <span className={classes.detailValue}>
                                                {selectedLead.physical_meeting_status || "N/A"}
                                            </span>
                                        </div>
                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>Meeting/Interaction Date:</span>
                                            <span className={classes.detailValue}>
                                                {selectedLead.meeting_date ?
                                                    moment(selectedLead.meeting_date).format("DD-MM-YYYY") : "N/A"}
                                            </span>
                                        </div>
                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>Final Lead Status:</span>
                                            <span className={classes.detailValue}>
                                                {selectedLead.lead_status || "N/A"}
                                            </span>
                                        </div>
                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>Sales/Channel Team Remarks:</span>
                                            <span className={classes.detailValue}>
                                                {selectedLead.sales_or_channel_team_remarks || "N/A"}
                                            </span>
                                        </div>
                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>1st Follow-Up Date:</span>
                                            <span className={classes.detailValue}>
                                                {selectedLead.first_followup_date ?
                                                    moment(selectedLead.first_followup_date).format("DD-MM-YYYY") : "N/A"}
                                            </span>
                                        </div>
                                        <div className={classes.detailRow}>
                                            <span className={classes.detailLabel}>2nd Follow-Up Date:</span>
                                            <span className={classes.detailValue}>
                                                {selectedLead.sec_followup_date ?
                                                    moment(selectedLead.sec_followup_date).format("DD-MM-YYYY") : "N/A"}
                                            </span>
                                        </div>
                                    </>
                                )}
                            </div>


                        </Box>
                    )}
                </DialogContent>
                <DialogActions style={{ padding: "16px 24px", borderTop: "1px solid #e0e0e0" }}>
                    {isEditMode ? (
                        <>
                            <Button
                                onClick={() => {
                                    setIsEditMode(false);
                                    setEditedLead({
                                        name: selectedLead.name || "",
                                        mobile: selectedLead.mobile || "",
                                        country_code: selectedLead.country_code || "+91",
                                        email: selectedLead.email || "",
                                        city: selectedLead.city_name || "",
                                        state: selectedLead.state_name || "",
                                        status: selectedLead.status || "New",
                                        competition_cc_name: selectedLead.competition_cc_name || "",
                                        shop_type: selectedLead.shop_type || "Owned",
                                        business_model_interest: selectedLead.business_model_interest || "Collection Center",
                                        tata_sales_caller_remarks: selectedLead.tata_sales_caller_remarks || "",
                                        url: selectedLead.url || "",
                                        disposition_id: selectedLead.disposition?.id || "",
                                        sub_disposition_id: selectedLead.sub_disposition?.id || "",
                                        assigned_user_id: selectedLead.assigned_user_id || "",
                                        prospect_contact_status: selectedLead.prospect_contact_status || "",
                                        interest_level: selectedLead.interest_level || "",
                                        current_profession: selectedLead.current_profession || "",
                                        business_model_interested_in: selectedLead.business_model_interested_in || "",
                                        physical_meeting_status: selectedLead.physical_meeting_status || "",
                                        meeting_interaction_date: selectedLead.meeting_interaction_date || "",
                                        final_lead_status: selectedLead.final_lead_status || "",
                                        sales_channel_team_remarks: selectedLead.sales_channel_team_remarks || "",
                                        first_followup_date: selectedLead.first_followup_date || "",
                                        second_followup_date: selectedLead.second_followup_date || "",
                                       
                                    });
                                }}
                                variant="outlined"
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={handleSaveEdit}
                                variant="contained"
                                style={{
                                    backgroundColor: "#4caf50",
                                    color: "#fff",
                                }}
                            >
                                Save Changes
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button onClick={() => setDetailsModal(false)} variant="outlined">
                                Close
                            </Button>
                            <Button
                                onClick={() => setIsEditMode(true)}
                                variant="contained"
                                style={{
                                    backgroundColor: "#ff9800",
                                    color: "#fff",
                                }}
                                startIcon={<EditIcon />}
                            >
                                Edit Details
                            </Button>
                            <Button
                                onClick={() => {
                                    setDetailsModal(false);
                                    handleDispositionOpen(selectedLead);
                                }}
                                variant="contained"
                                color="secondary"
                            >
                                Update Disposition
                            </Button>
                            <Button
                                onClick={() => {
                                    setDetailsModal(false);
                                    handleAssignOpen(selectedLead);
                                }}
                                variant="contained"
                                color="primary"
                            >
                                Assign Lead
                            </Button>
                        </>
                    )}
                </DialogActions>
            </Dialog>

            {/* Disposition Modal */}
            <Dialog
                open={dispositionModal}
                onClose={() => setDispositionModal(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Update Disposition</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} style={{ marginTop: "8px" }}>
                        <Grid item xs={12}>
                            <Autocomplete
                                id="disposition"
                                value={
                                    franchiseDispositionList?.results?.find(
                                        (d: any) => d.id === disposition
                                    ) || null
                                }
                                onChange={(event, newValue) => {
                                    if (newValue) {
                                        setDisposition(newValue.id);
                                        setSubDisposition("");
                                    } else {
                                        setDisposition("");
                                        setSubDisposition("");
                                    }
                                }}
                                options={franchiseDispositionList?.results || []}
                                getOptionLabel={(option: any) => option.name || ""}
                                renderInput={(params) => (
                                    <TextField
                                        className="input"
                                        {...params}
                                        label="Disposition"
                                        variant="outlined"
                                        style={{ width: "100%", margin: "0", padding: "0" }}
                                    />
                                )}
                            />
                        </Grid>
                        {disposition && (
                            <Grid item xs={12}>
                                <Autocomplete
                                    id="sub-disposition"
                                    value={
                                        franchiseDispositionList?.results
                                            ?.find((d: any) => d.id === disposition)
                                            ?.sub_disposition_list?.find(
                                                (sd: any) => sd.id === subDisposition
                                            ) || null
                                    }
                                    onChange={(event, newValue) => {
                                        if (newValue) {
                                            setSubDisposition(newValue.id);
                                        } else {
                                            setSubDisposition("");
                                        }
                                    }}
                                    options={
                                        franchiseDispositionList?.results
                                            ?.find((d: any) => d.id === disposition)
                                            ?.sub_disposition_list || []
                                    }
                                    getOptionLabel={(option: any) => option.name || ""}
                                    renderInput={(params) => (
                                        <TextField
                                            className="input"
                                            {...params}
                                            label="Sub Disposition"
                                            variant="outlined"
                                            style={{ width: "100%", margin: "0", padding: "0" }}
                                        />
                                    )}
                                />
                            </Grid>
                        )}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDispositionModal(false)}>
                        Cancel
                    </Button>
                    <Button onClick={handleDispositionUpdate} color="primary" variant="contained">
                        Update
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Assign User Modal */}
            <Dialog
                open={assignModal}
                onClose={() => setAssignModal(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Assign Lead</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} style={{ marginTop: "8px" }}>
                        <Grid item xs={12}>
                            <Autocomplete
                                id="assign-user"
                                value={
                                    franchiseAssignUserList?.results?.find(
                                        (user: any) => user.id === selectedUser
                                    ) || null
                                }
                                onChange={(event, newValue) => {
                                    if (newValue) {
                                        setSelectedUser(newValue.id);
                                    } else {
                                        setSelectedUser("");
                                    }
                                }}
                                options={franchiseAssignUserList?.results || []}
                                getOptionLabel={(option: any) => option.username || ""}
                                onInputChange={(event, newInputValue) => {
                                    clearTimeout(timer.current);
                                    timer.current = setTimeout(() => {
                                        getFranchiseAssignUserList(`name=${newInputValue.replace(" ", "")}`);
                                    }, 1000);
                                    if (newInputValue.length === 0) {
                                        setSelectedUser([]);
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        className="input"
                                        {...params}
                                        label="Select User"
                                        variant="outlined"
                                        style={{ width: "100%", margin: "0", padding: "0" }}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setAssignModal(false)}>
                        Cancel
                    </Button>
                    <Button onClick={handleAssignUpdate} color="primary" variant="contained">
                        Assign
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Logs Dialog */}
            <Dialog
                open={openLogsModel}
                onClose={handleClose}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    style: {
                        borderRadius: "12px",
                        boxShadow: "0 6px 18px rgba(0, 0, 0, 0.1)",
                        overflow: "hidden",
                    },
                }}
            >
                <DialogTitle
                    style={{
                        background: "linear-gradient(90deg, #0E3F6C, #1E5A99)",
                        color: "#fff",
                        fontWeight: 600,
                        padding: "12px 20px",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <Typography variant="h6" style={{ fontSize: "18px", fontWeight: 600 }}>
                            Comment History
                        </Typography>
                        <div>
                            {Number(maxHeight) === 300 ? (
                                <IconButton
                                    onClick={() => setMaxHeight(600)}
                                    size="small"
                                    style={{ color: "#fff" }}
                                >
                                    <ZoomOutMapIcon />
                                </IconButton>
                            ) : (
                                <IconButton
                                    onClick={() => setMaxHeight(300)}
                                    size="small"
                                    style={{ color: "#fff" }}
                                >
                                    <ZoomInMapIcon />
                                </IconButton>
                            )}
                        </div>
                    </div>
                </DialogTitle>

                <DialogContent
                    dividers
                    style={{
                        padding: 0,
                        backgroundColor: "#fafafa",
                    }}
                >
                    <div
                        style={{
                            height: `${maxHeight}px`,
                            overflowY: "auto",
                            padding: "16px 20px",
                        }}
                    >
                        {loading ? (
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "100%",
                                }}
                            >
                                <CircularProgress style={{ color: "#0E3F6C" }} />
                            </div>
                        ) : Array.isArray(franchiseInquiryLogs?.results) &&
                            franchiseInquiryLogs.results.length > 0 ? (
                            <div>
                                {franchiseInquiryLogs.results.map((comment: any, index: number) => (
                                    <Box
                                        key={index}
                                        style={{
                                            marginBottom: "16px",
                                            padding: "14px 16px",
                                            backgroundColor: "#fff",
                                            borderRadius: "10px",
                                            boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                                            borderLeft: "5px solid #0E3F6C",
                                            transition: "transform 0.2s ease",
                                        }}
                                        onMouseEnter={(e) =>
                                            (e.currentTarget.style.transform = "translateY(-2px)")
                                        }
                                        onMouseLeave={(e) =>
                                            (e.currentTarget.style.transform = "translateY(0)")
                                        }
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                marginBottom: "8px",
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                style={{
                                                    fontWeight: 600,
                                                    color: "#0E3F6C",
                                                    fontSize: "14px",
                                                }}
                                            >

                                            </Typography>
                                            <Typography
                                                variant="caption"
                                                style={{
                                                    color: "#666",
                                                    fontSize: "12px",
                                                    fontStyle: "italic",
                                                }}
                                            >
                                                {comment?.created_at
                                                    ? moment(comment.created_at).format("DD-MM-YYYY HH:mm:ss")
                                                    : "N/A"}
                                            </Typography>
                                        </div>

                                        <Typography
                                            variant="body2"
                                            style={{
                                                color: "#333",
                                                lineHeight: 1.6,
                                                fontSize: "14px",
                                            }}
                                        >
                                            {comment?.comment || "No comment"}
                                        </Typography>
                                    </Box>
                                ))}
                            </div>
                        ) : (
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "100%",
                                    color: "#999",
                                    flexDirection: "column",
                                }}
                            >
                                <Typography variant="body1" style={{ marginBottom: "4px" }}>
                                    No logs available
                                </Typography>
                                <Typography
                                    variant="caption"
                                    style={{ color: "#bbb", fontStyle: "italic" }}
                                >
                                    (New comments will appear here)
                                </Typography>
                            </div>
                        )}
                    </div>
                </DialogContent>

                <DialogActions
                    style={{
                        borderTop: "1px solid rgba(0,0,0,0.12)",
                        padding: "10px 16px",
                        backgroundColor: "#f9f9f9",
                    }}
                >
                    <Button
                        onClick={handleClose}
                        variant="outlined"
                        style={{
                            borderColor: "#0E3F6C",
                            color: "#0E3F6C",
                            textTransform: "none",
                            fontWeight: 600,
                        }}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    );
};

const mapStateToProps = (state: any) => ({
    franchiseList: state.OffLineSupporteReducer.franchiseList,
    loading: state.OffLineSupporteReducer.loading,
    usersList: state.OffLineSupporteReducer.usersList,
    franchiseById: state.OffLineSupporteReducer.franchiseById,
    franchiseDispositionList: state.OffLineSupporteReducer.franchiseDispositionList,
    cities: state.OffLineSupporteReducer.cities,
    franchiseAssignUserList: state.OffLineSupporteReducer.franchiseAssignUserList,
    franchiseInquiryLogs: state.OffLineSupporteReducer.franchiseInquiryLogs,
    displayCities: state.OffLineSupporteReducer.displayCities
});

export default connect(mapStateToProps, {
    getFranchiseInquiryList,
    clickToCallMobile,
    getUserDetails,
    getFranchiseInquiryDataById,
    getFranchiseDispositionList,
    getCities,
    updateFranchiseData,
    getFranchiseAssignUserList,
    getFranchiseInquiryLogs,
    createFranchiseInquiry,
    getDisplayCities
})(FranchiseLeads);